import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import { InitiativeDiscussionIcon, ViewGlyph12Icon } from 'assets/icons'
import InitiativeDefaultThumbnail from 'src/apps/Initiative/components/DefaultThumbnail'
import InitiativePrivacyBadge from 'src/apps/Initiative/components/PrivacyBadge'

const InitiativeListItemRow = ({
   archived,
   borderStyle,
   coverUrl,
   dateLastUpdated,
   initiativeTypeHighlightColor,
   initiativeTypeIconName,
   linkTo,
   name,
   numThreadEntries,
   numViews,
   pinned,
   privacy,
   showStats,
   typeSlug
}) => (
   <Link to={linkTo}>
      <View
         display="flex"
         alignItems="center"
         width="100%"
         padding="20px 10px"
         borderTop={borderStyle}
         className={css`
            &:hover {
               background-color: rgba(56, 170, 242, 0.03);
            }
         `}>
         <View
            flex="0 0 auto"
            width="30px"
            height="30px"
            borderRadius="3px"
            backgroundColor="#eee"
            backgroundImage={`url(${coverUrl})`}
            backgroundSize="cover"
            backgroundPosition="center center"
            marginRight="20px"
            style={{ overflow: 'hidden' }}>
            {!coverUrl && (
               <InitiativeDefaultThumbnail
                  highlightColor={initiativeTypeHighlightColor}
                  iconName={initiativeTypeIconName}
               />
            )}
         </View>
         <View
            display="flex"
            flex="1 1 auto"
            flexFlow="column[a-b] row[c-f]"
            opacity={archived && '0.5'}>
            <View flex="1 1 auto" paddingRight="60px[c-f]">
               <View display="flex" alignItems="center">
                  <Text size="2" weight="medium" color="#222">
                     {name}
                  </Text>
                  {archived && (
                     <View
                        display="inline-flex"
                        alignItems="center"
                        height="15px"
                        border="1px solid #ddd"
                        padding="0px 5px"
                        borderRadius="3px"
                        marginLeft="10px">
                        <Text size="0.7" weight="bold" transform="uppercase" color="#777">
                           Archived
                        </Text>
                     </View>
                  )}
               </View>
               <InitiativePrivacyBadge privacy={privacy} />
               <Text size="1" color="#888">
                  {`Last updated ${dateLastUpdated}`}
               </Text>
            </View>
            <View
               display={showStats ? 'flex' : 'none'}
               alignItems="center"
               flex="0 0 auto"
               paddingRight="15px">
               {numThreadEntries > 0 && (
                  <View display="flex" alignItems="center" marginRight="15px">
                     <View marginRight="5px">
                        <InitiativeDiscussionIcon
                           width="12px"
                           height="12px"
                           color="#aaa"
                        />
                     </View>
                     <Text size="1" color="#aaa">
                        {`${pluralize('Comments', numThreadEntries, true)} `}
                     </Text>
                  </View>
               )}
               {numViews > 0 && (
                  <>
                     <View margin="0px 5px 0px 0px">
                        <ViewGlyph12Icon
                           width="12px"
                           height="12px"
                           color="#aaa"
                        />
                     </View>
                     <Text size="1" color="#aaa">
                        {pluralize('Views', numViews, true)}
                     </Text>
                  </>
               )}
            </View>
         </View>
      </View>
   </Link>
)

InitiativeListItemRow.propTypes = {
   archived: PropTypes.bool,
   borderStyle: PropTypes.string,
   coverUrl: PropTypes.string,
   dateLastUpdated: PropTypes.string.isRequired,
   initiativeTypeHighlightColor: PropTypes.string,
   initiativeTypeIconName: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   numThreadEntries: PropTypes.number.isRequired,
   numViews: PropTypes.number.isRequired,
   pinned: PropTypes.bool,
   privacy: PropTypes.string.isRequired,
   showStats: PropTypes.bool,
   typeSlug: PropTypes.string.isRequired
}

InitiativeListItemRow.defaultProps = {
   archived: false,
   borderStyle: '1px solid rgba(0,0,0,0.075)',
   coverUrl: undefined,
   initiativeTypeHighlightColor: undefined,
   initiativeTypeIconName: undefined,
   pinned: false,
   showStats: true
}

export default InitiativeListItemRow
